import { FileData } from '../reducers/fileState';
import { InputElementAEMProps } from '../model/AemDataProps';
import { Option } from '../model/IFormModel';
import { IDocumentListItemProps } from '../model/IGetAllFileDataParams';

export const getListItemProp = (source: FileData): IDocumentListItemProps => ({
  // eslint-disable-next-line no-underscore-dangle
  _id: source._id,
  date: convertTimestampToDate(source.lastModifiedDate),
  fileSize: convertToReadableFormat(source.fileSize),
  fileUrl: source.fileUrl,
  image: 'assets/demo-files/cad-file-demo.png',
  title: source.title,
  modelYear: source.modelYear,
  bulletinNumber: source.bulletinNumber,
  description: source.description,
  nameplate: source.nameplate,
  quarter: source.quarter,
  language: source.language,
  bodystyle: source.bodystyle,
  year: source.year,
  category: source.category,
  englishTitle: source.englishTitle,
  fileName: source.fileName,
  aemFilePath: source.aemFilePath,
});

export function getOptionForLabel(label: string, options: Option[]): Option | undefined {
  return options.find((option: Option) => option.label === label);
}

export function getOptionForValue(value: string, options: Option[]): Option | undefined {
  return options.find((option: Option) => option.value === value);
}

export const validateField = (value: string, validator: InputElementAEMProps) => {
  if (value.length === 0 && validator.requiredErrorMessage) {
    return validator.requiredErrorMessage;
  }

  if (value.length !== 0 && validator.regEx) {
    const evalRegEx = new RegExp(validator.regEx);
    const errorMsg = validator.validationErrorMessage
      ? validator.validationErrorMessage
      : 'Invalid input';
    return evalRegEx.test(value) ? '' : errorMsg;
  }

  return '';
};

export const convertToReadableFormat = (size: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let i = 0;

  while (size >= 1024) {
    size /= 1024;
    ++i;
  }

  return `${(size || 0).toFixed(1)} ${units[i]}`;
};

export const convertTimestampToDate = (timestamp: string) => {
  const date = new Date(timestamp);

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const getNavigateUrl = (replacePath: string) => {
  const currentPath = window.location.href;
  // replaces last string with path param
  const url = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;
  const pathSegments = url.split('/');
  pathSegments[pathSegments.length - 1] = replacePath;
  return pathSegments.join('/');
};

export const convertDateToLocaleFormat = (date: string) => {
  const dateString = date;
  const newDate = new Date(dateString);
  const dateFormat = newDate.toLocaleDateString();

  return dateFormat;
};

export const createClone = <T>(data: T) => JSON.parse(JSON.stringify(data)) as T;

export const GET_YEARS = (isModelYear: boolean) => {
  const earliestYear = 2006;
  const latestYear = 2030;

  const years = [];

  for (let i = earliestYear; i <= latestYear; i += 1) {
    const y = `${i}`;

    years.push({ id: y, value: y, label: y });

    if (isModelYear) {
      const y25 = `${y}.25`;
      const y5 = `${y}.5`;
      const y75 = `${y}.75`;

      years.push({ id: y25, value: y25, label: y25 });
      years.push({ id: y5, value: y5, label: y5 });
      years.push({ id: y75, value: y75, label: y75 });
    }
  }

  return years;
};

export const getNameplateValue = (nameplate: string) =>
  nameplate.toLowerCase() === 'all' ? '' : nameplate;

export const getFileNameFromUrl = (fileUrl: string) => fileUrl?.split('/').pop().split('?')[0];

export const removeHtmlTags = (htmlRegex: RegExp, sourceString: string) =>
  sourceString.replace(htmlRegex, '');

export function rightTrim(text: string, char: string): string {
  return text.replace(new RegExp(`${char}+$`), '');
}

export function leftTrim(text: string, char: string): string {
  return text.replace(new RegExp(`^${char}+`), '');
}

export function getReadableFileTypes(text: string): string {
  const fileTypeMap: { [key: string]: string } = {
    Low: 'PDF Lo',
    High: 'PDF Hi',
    EPS: 'EPS',
    PSD: 'PSD',
  };
  return fileTypeMap[text] || text;
}
